/* globals CSRF_TOKEN */

import 'zoomforth_file_uploader/file-uploader-shim.js';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import autobind from 'class-autobind';

import InfoPanelAssetUI from './info_panel.asset_ui.jsx';
import { sendRequestWithPromise } from 'zoomforth_zfutils/xhr_tools.js';

import VideoThumbnailPickerView from '../views/video_thumbnail_picker.js';
import zfHelpers, { displayFixedErrorAlertForXhrFail } from 'zoomforth_tools/modern_helpers.js';

import { defaultDatetimeFormat } from 'zoomforth_zfutils/datetime_formatting.js';


class InfoPanelAsset extends Component {

  constructor(props) {
    super(props);
    autobind(this);
    this.node = undefined;

    this.state = {
      shouldShowReplaceAssetModal: false,
      shouldShowAssetSiteListModal: false,
      didSiteListFetchError: false
    };
  }

  componentDidMount() {
    this.setUpBackboneBindings(this.props.asset);
    
    sendRequestWithPromise({
      url: 'rpc/get_asset_site_list',
      method: 'POST',
      params: {
        asset_ident: this.props.asset.id
      }
    })
    .then((response) => this.setState({ siteList: response.sites }))
    .catch((error) => this.setState({ siteList: [], didSiteListFetchError: true }));
  }

  componentWillUpdate(nextProps) {
    if (this.props.asset.id !== nextProps.asset.id) {
      this.tearDownBackboneBindings(this.props.asset);
      this.tearDownDOMBindings(this.node);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.asset.id !== prevProps.asset.id) {
      this.setUpBackboneBindings(this.props.asset);
      this.setUpDOMBindings(this.node);
    }
  }

  componentWillUnmount() {
    this.tearDownBackboneBindings(this.props.asset);
  }

  setUpBackboneBindings(asset) {
    asset.on('change', ()=> {
      this.forceUpdate();
    }, this);
  }

  tearDownBackboneBindings(asset) {
    asset.off(null, null, this);
  }

  setUpDOMBindings(node) {
    this.bindPDFUpdater(node);
    this.bindOtherUpdater(node);
    this.bindSubtitleUploader(node);
    this.setupDescription(node);
  }

  tearDownDOMBindings(node) {
    if ($(node).find('.action-update-pdf').hasClass('initialize')) {
      $(node).find('.action-update-pdf').fileupload('destroy');
    }

    if ($(node).find('.action-update-other').hasClass('initialize')) {
      $(node).find('.action-update-other').fileupload('destroy');
    }

    if ($(node).find('.action-set-video-subtitles').hasClass('initialize')) {
      $(node).find('.action-set-video-subtitles').fileupload('destroy');
    }
  }

  handleRefAttach(node) {
    if (node) { // Mounting
      this.node = node;
      this.setUpDOMBindings(node);

    } else if (this.node) { // Unmounting
      this.tearDownDOMBindings(this.node);
    }
  }

  setupDescription(node) {
    $(node).find('.asset-default-description-text-area').find('a').attr('target', '_blank');
  }

  bindPDFUpdater(node) {
    // should have checked to make sure we are dealing with a pdf before calling this
    const model = this.props.asset;

    $(node).find('.action-update-pdf').addClass('initialized');

    $(node).find('.action-update-pdf').fileupload({
      url: '/rpc/pdf/update',
      dataType: 'json',
      dropZone: null,
      formData: {
        csrf_token: CSRF_TOKEN, 
        pdf_id: model.get('assetId')
      },
      add: function(e, data){
        zfHelpers.confirm(['Updating this PDF will remove the old version in all sites that include it, ',
          'and replace it with the new version. ',
          'Are you sure you want to continue?',
          '<br/><br/>Please be sure that it is not better to upload the new version as a new asset.'
        ].join('')).done(function(){
          $.fancybox.showLoading();
          data.submit().fail(displayFixedErrorAlertForXhrFail);
        });
      },
      done: function(){
        model.fetch().done(function(){
          $.fancybox.hideLoading();
        });
      },
      fail: displayFixedErrorAlertForXhrFail
    });
  }


  bindOtherUpdater(node) {
    var model = this.props.asset;

    $(node).find('.action-update-other').addClass('initialized');

    $(node).find('.action-update-other').fileupload({
      url: '/other/update',
      dataType: 'json',
      dropZone: null,
      formData: {
        csrf_token: CSRF_TOKEN, 
        asset_id: model.get('assetId')
      },
      add: function(e, data){
        zfHelpers.confirm(['Updating this file will remove the old version in all sites that include it, ',
          'and replace it with the new version. ',
          'Are you sure you want to continue?',
          '<br/><br/>Please be sure that it is not better to upload the new version as a new asset.'
        ].join('')).done(function(){
          $.fancybox.showLoading();
          data.submit().fail(displayFixedErrorAlertForXhrFail);
        });
      },
      done: function(e){
        model.fetch().done(function(){
          $.fancybox.hideLoading();
        });
      },
      fail: displayFixedErrorAlertForXhrFail
    });
  }


  bindSubtitleUploader(node) {
    var model = this.props.asset;

    $(node).find('.action-set-video-subtitles').addClass('initialized');

    $(node).find('.action-set-video-subtitles').fileupload({
      url: '/video/subtitles',
      dataType: 'json',
      dropZone: null,
      formData: {
        csrf_token: CSRF_TOKEN,
        asset_ident: model.get('assetType') + '-' + model.get('assetId')
      },
      add: function(e, data) {
        $.fancybox.showLoading();
        data.submit()
          .fail(displayFixedErrorAlertForXhrFail);
      },
      done: function(e) {
        model.fetch().done(function(){
          $.fancybox.hideLoading();
        });
      },
      fail: displayFixedErrorAlertForXhrFail
    });
  }

  handleDeleteSubtitles() {
    var video = this.props.asset;
    video.save({
      subtitles: null
    }, {patch: true});
  }


  handleChooseVideoThumbnail(){
    var video = this.props.asset;
    if (video.get('assetType') !== 'video') {
      return;
    }
    VideoThumbnailPickerView.show({ asset:video })

      .done(function() { 
        video.fetch(); // Refresh the video
      });
  }

  handleChangeIsFilenameUsedAsTitle(isFilenameUsedAsTitle) {

    this.props.asset.save({
      use_default_title: isFilenameUsedAsTitle

    }, {patch: true});

  }

  handleRenameSave(newName) {

    return this.props.asset.rename(newName);
  }

  handleDescriptionSave(newDesc) {
    return this.props.asset.save({
      caption: newDesc,
      renderedCaption: newDesc

    }, { patch:true });
  }

  handleShouldShowReplaceAssetModal(shouldShowReplaceAssetModal){
    this.setState({ shouldShowReplaceAssetModal });
  }

  handleShouldShowAssetSiteListModalChange(shouldShowAssetSiteListModal){
    this.setState({ shouldShowAssetSiteListModal });
  }
  
  handleAltTextSave(newAltText) {
    return this.props.asset.save({
      default_alt_text: newAltText
    }, { patch: true });
  }

  render() {

    const { 
      asset,
      isInSearchMode,
      pathAsFolderData,
      currentFolder,
      onAssetExpand,
      onDeleteClick,
      onFolderNavigate,
      onMoveClick,
      onAssetReplace,
      onClearAssetSelection
    } = this.props;

    const { 
      shouldShowReplaceAssetModal,
      shouldShowAssetSiteListModal,
      siteList,
      didSiteListFetchError
    } = this.state;

    const assetType = asset.get('assetType');
    const createdAt = defaultDatetimeFormat(asset.getCreatedAt(), { includeTime:true });
    const description = asset.getDescription();
    const altText = asset.getAltText();
    const displayImageUrl = asset.get('displayImage');
    const isFilenameUsedAsTitle = asset.get('use_default_title');
    const isPlayable = asset.isPlayable();
    const lastModifiedAt = defaultDatetimeFormat(asset.getLastModifiedAt(), { includeTime:true });
    const name = asset.getName();
    const uploadedByUserDisplayName = asset.getUploadPerson();
    const subtitles = asset.get('subtitles');

    return (
      <InfoPanelAssetUI 
        key={asset.get('assetId')}
        currentFolder={currentFolder}
        asset={asset}
        assetType={assetType}
        assetDownloadUrl={asset.getDownloadUrl()}
        createdAt={createdAt}
        description={description}
        altText={altText}
        displayImageUrl={displayImageUrl}
        isInSearchMode={isInSearchMode}
        isFilenameUsedAsTitle={isFilenameUsedAsTitle}
        isPlayable={isPlayable}
        lastModifiedAt={lastModifiedAt}
        name={name}
        pathAsFolderData={pathAsFolderData}
        subtitles={subtitles}
        siteList={siteList}
        didSiteListFetchError={didSiteListFetchError}
        uploadedByUserDisplayName={uploadedByUserDisplayName}
        shouldShowReplaceAssetModal={shouldShowReplaceAssetModal}
        shouldShowAssetSiteListModal={shouldShowAssetSiteListModal}
        onAssetInfoAreaRefAttach={this.handleRefAttach}
        onDeleteClick={onDeleteClick}
        onAssetReplace={onAssetReplace}
        onDeleteVideoSubtitlesClick={this.handleDeleteSubtitles}
        onExpandClick={()=> { onAssetExpand(asset); }}
        onFolderNavigate={onFolderNavigate}
        onChooseVideoThumbnailClick={this.handleChooseVideoThumbnail}
        onIsFilenameUsedAsTitleChange={this.handleChangeIsFilenameUsedAsTitle}
        onMoveClick={onMoveClick}
        onRenameSave={this.handleRenameSave}
        onDescriptionSave={this.handleDescriptionSave}
        onShouldShowAssetSiteListModalChange={this.handleShouldShowAssetSiteListModalChange}
        onShouldShowReplaceAssetModal={this.handleShouldShowReplaceAssetModal}
        onClearAssetSelection={onClearAssetSelection}
        onAltTextSave={this.handleAltTextSave}
      />
    );
  }
}

InfoPanelAsset.propTypes = {
  isInSearchMode: PropTypes.bool.isRequired,
  asset: PropTypes.object.isRequired,
  pathAsFolderData: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number
  })).isRequired,
  onMoveClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  onAssetExpand: PropTypes.func.isRequired
};

export default InfoPanelAsset;
